/*** Module to add a shipping rates calculator to cart page. * Modified by David Little, 2016 */
if (typeof Countries === "object") {
  Countries.updateProvinceLabel = function(country, labelElement) {
    if (typeof country !== "string" || !Countries[country] || !Countries[country].provinces) {
      return;
    }

    if (typeof labelElement !== "object") {
      labelElement = document.getElementById("address_province_label");
      if (labelElement === null) {
        return;
      }
    }

    labelElement.innerHTML = Countries[country].label;

    var $wrapper = jQuery(labelElement).parent();
    $wrapper.find(".custom-style-select-box-inner").html(Countries[country].provinces[0]);
  };
}

if (typeof Shopify.Cart === "undefined") {
  Shopify.Cart = {};
}

Shopify.Cart.ShippingCalculator = (function() {
  var _config = {
    submitButton: "Calculate shipping",
    submitButtonDisabled: "Calculating...",
    templateId: "shipping-calculator-response-template",
    wrapperId: "wrapper-response",
    customerIsLoggedIn: false,
    moneyFormat: theme.moneyFormat
  };

  function _render(response) {
    var $template = jQuery("#" + _config.templateId);
    var $wrapper = jQuery("#" + _config.wrapperId);

    if (!$template.length || !$wrapper.length) {
      return;
    }

    var template = Handlebars.compile(jQuery.trim($template.text()));
    var html = template(response);

    jQuery(html).appendTo($wrapper);

    if (typeof Currency !== "undefined" && typeof Currency.convertAll === "function") {
      var currentCurrency = "";

      if (jQuery("[name=currencies]").length) {
        currentCurrency = jQuery("[name=currencies]").val();
      } else if (jQuery("#currencies li.selected").length) {
        currentCurrency = jQuery("#currencies li.selected").attr("data-currency");
      }

      if (currentCurrency !== "") {
        Currency.convertAll(shopCurrency, currentCurrency, "#wrapper-response span.money, #estimated-shipping span.money");
      }
    }
  }

  function _enableButtons() {
    jQuery(".get-rates").removeAttr("disabled").removeClass("disabled").val(_config.submitButton);
  }

  function _disableButtons() {
    jQuery(".get-rates").val(_config.submitButtonDisabled).attr("disabled", "disabled").addClass("disabled");
  }

  function _getCartShippingRatesForDestination(destination) {
    jQuery.ajax({
      type: "POST",
      url: "/cart/prepare_shipping_rates",
      data: jQuery.param({ shipping_address: destination }),
      success: _pollForCartShippingRatesForDestination(destination),
      error: _onError
    });
  }

  function _pollForCartShippingRatesForDestination(destination) {
    var poll = function() {
      jQuery.ajax("/cart/async_shipping_rates", {
        dataType: "json",
        success: function(response, _textStatus, xhr) {
          if (xhr.status === 200) {
            _onCartShippingRatesUpdate(response.shipping_rates, destination);
          } else {
            setTimeout(poll, 500);
          }
        },
        error: _onError
      });
    };

    return poll;
  }

  function _fullMessagesFromErrors(errors) {
    var fullMessages = [];

    jQuery.each(errors, function(attribute, messages) {
      jQuery.each(messages, function(_index, message) {
        fullMessages.push(attribute + " " + message);
      });
    });

    return fullMessages;
  }

  function _onError(XMLHttpRequest) {
    jQuery("#estimated-shipping").hide();
    jQuery("#estimated-shipping em").empty();
    _enableButtons();

    var feedback = "";
    var data = eval("(" + XMLHttpRequest.responseText + ")");

    feedback = data.message
      ? data.message + "(" + data.status + "): " + data.description
      : "Error : " + _fullMessagesFromErrors(data).join("; ") + ".";

    if (feedback === "Error : country is not supported.") {
      feedback = "We do not ship to this destination.";
    }

    _render({
      rates: [],
      errorFeedback: feedback,
      success: false
    });

    jQuery("#" + _config.wrapperId).show();
  }

  function _onCartShippingRatesUpdate(rates, address) {
    _enableButtons();

    var addressSummary = "";

    if (address.zip) {
      addressSummary += address.zip + ", ";
    }

    if (address.province) {
      addressSummary += address.province + ", ";
    }

    addressSummary += address.country;

    if (rates.length) {
      if (rates[0].price === "0.00") {
        jQuery("#estimated-shipping em").html("FREE");
      } else {
        jQuery("#estimated-shipping em").html(_formatRate(rates[0].price));
      }

      for (var i = 0; i < rates.length; i += 1) {
        rates[i].price = _formatRate(rates[i].price);
      }
    }

    _render({
      rates: rates,
      address: addressSummary,
      success: true
    });

    jQuery("#" + _config.wrapperId + ", #estimated-shipping").fadeIn();
  }

  function _formatRate(rate) {
    function defaultValue(value, fallback) {
      return typeof value === "undefined" ? fallback : value;
    }

    function formatWithDelimiters(amount, precision, thousands, decimal) {
      precision = defaultValue(precision, 2);
      thousands = defaultValue(thousands, ",");
      decimal = defaultValue(decimal, ".");

      if (isNaN(amount) || amount == null) {
        return 0;
      }

      amount = (amount / 100).toFixed(precision);

      var parts = amount.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var cents = parts[1] ? decimal + parts[1] : "";

      return dollars + cents;
    }

    if (typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(rate, _config.moneyFormat);
    }

    if (typeof rate === "string") {
      rate = rate.replace(".", "");
    }

    var formatted = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var format = _config.moneyFormat;

    switch (format.match(placeholderRegex)[1]) {
      case "amount":
        formatted = formatWithDelimiters(rate, 2);
        break;
      case "amount_no_decimals":
        formatted = formatWithDelimiters(rate, 0);
        break;
      case "amount_with_comma_separator":
        formatted = formatWithDelimiters(rate, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        formatted = formatWithDelimiters(rate, 0, ".", ",");
        break;
    }

    return format.replace(placeholderRegex, formatted);
  }

  function _normalizeCountryName(name) {
    return String(name || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/&/g, "and")
      .replace(/[().,'’]/g, "")
      .replace(/\s+/g, " ")
      .trim();
  }

  function _resolveCountryValue($countrySelect, rawCountry) {
    if (!rawCountry) {
      return "";
    }

    var normalizedRaw = _normalizeCountryName(rawCountry);
    var matchedValue = "";

    $countrySelect.find("option").each(function() {
      var optionValue = jQuery(this).val();
      var optionText = jQuery(this).text();

      if (
        _normalizeCountryName(optionValue) === normalizedRaw ||
        _normalizeCountryName(optionText) === normalizedRaw
      ) {
        matchedValue = optionValue;
        return false;
      }
    });

    return matchedValue;
  }

  function _getGeoDetectedCountryValue($countrySelect) {
    var countryCode = window.__saGeoCountry || (window.Shopify && window.Shopify.country) || "";

    if (!countryCode) {
      return "";
    }

    var aliasByCode = {
      GB: "United Kingdom",
      US: "United States",
      AE: "United Arab Emirates"
    };

    var resolvedName = aliasByCode[countryCode] || "";

    if (!resolvedName && typeof Intl !== "undefined" && typeof Intl.DisplayNames === "function") {
      try {
        resolvedName = new Intl.DisplayNames(["en"], { type: "region" }).of(countryCode) || "";
      } catch (_error) {
        resolvedName = "";
      }
    }

    return _resolveCountryValue($countrySelect, resolvedName);
  }

  function _getSelectedCountryValue($countrySelect) {
    var selectedValue = $countrySelect.val();

    if (selectedValue) {
      return selectedValue;
    }

    var selectedText = $countrySelect.find("option:selected").text();
    return _resolveCountryValue($countrySelect, selectedText);
  }

  function _applyPreferredCountry($countrySelect, countryValue) {
    if (!countryValue) {
      return false;
    }

    if ($countrySelect.attr("data-default") !== countryValue) {
      $countrySelect.attr("data-default", countryValue);
    }

    if ($countrySelect.val() !== countryValue) {
      $countrySelect.val(countryValue).trigger("change");
      return true;
    }

    return false;
  }

  function _syncCountryWithGeoDetection($countrySelect) {
    if (_config.customerIsLoggedIn) {
      return;
    }

    var attempts = 0;
    var maxAttempts = 20;
    var interval = window.setInterval(function() {
      attempts += 1;

      var detectedCountry = _getGeoDetectedCountryValue($countrySelect);

      if (detectedCountry) {
        _applyPreferredCountry($countrySelect, detectedCountry);
        window.clearInterval(interval);
        return;
      }

      if (attempts >= maxAttempts) {
        window.clearInterval(interval);
      }
    }, 500);
  }

  function _applyGuestProvincePlaceholder() {
    if (_config.customerIsLoggedIn) {
      return;
    }

    var $province = jQuery("#address_province");
    var $provinceContainer = jQuery("#address_province_container");

    if (!$province.length || !$provinceContainer.length || !$provinceContainer.is(":visible")) {
      return;
    }

    if (($province.attr("data-default") || "").trim() !== "") {
      return;
    }

    if (!$province.find("option").length) {
      return;
    }

    var labelText = jQuery.trim(jQuery("#address_province_label").text()) || "State/Province";
    var placeholderText = "Select " + labelText;
    var $emptyOption = $province.find('option[value=""]');

    if ($emptyOption.length) {
      $emptyOption.first().text(placeholderText);
    } else {
      $province.prepend(jQuery("<option></option>").val("").text(placeholderText));
    }

    $province.val("");

    var $customInner = $province.parent().find(".custom-style-select-box-inner");
    if ($customInner.length) {
      $customInner.text(placeholderText);
    }
  }

  function _init() {
    var $country = jQuery("#address_country");
    var provinceLabel = jQuery("#address_province_label").get(0);

    if (!_config.customerIsLoggedIn) {
      var preferredCountry =
        _getGeoDetectedCountryValue($country) ||
        _getSelectedCountryValue($country) ||
        $country.attr("data-default") ||
        "";

      _applyPreferredCountry($country, preferredCountry);
    }

    new Shopify.CountryProvinceSelector("address_country", "address_province", {
      hideElement: "address_province_container"
    });

    _applyGuestProvincePlaceholder();

    if (typeof Countries !== "undefined") {
      Countries.updateProvinceLabel($country.val(), provinceLabel);
      $country.on("change", function() {
        Countries.updateProvinceLabel($country.val(), provinceLabel);
        window.setTimeout(_applyGuestProvincePlaceholder, 0);
      });
    }

    if (!_config.customerIsLoggedIn) {
      _applyPreferredCountry($country, _getGeoDetectedCountryValue($country) || _getSelectedCountryValue($country));
      _syncCountryWithGeoDetection($country);
    }

    jQuery(".get-rates").on("click", function() {
      _disableButtons();
      jQuery("#" + _config.wrapperId).empty().hide();

      var destination = {
        zip: jQuery("#address_zip").val() || "",
        country: jQuery("#address_country").val() || "",
        province: jQuery("#address_province").val() || ""
      };

      _getCartShippingRatesForDestination(destination);
    });

    if (_config.customerIsLoggedIn) {
      jQuery(".get-rates:eq(0)").trigger("click");
    }
  }

  return {
    show: function(options) {
      options = options || {};
      jQuery.extend(_config, options);
      jQuery(function() {
        _init();
      });
    },
    getConfig: function() {
      return _config;
    },
    formatRate: function(rate) {
      return _formatRate(rate);
    }
  };
})();